export const RELATIVE_TO_BENCHMARK_BANNER_IMAGE = `
<svg width="96px" height="13px" viewBox="0 0 96 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Badge / Benchmark</title>
    <g id="PDF-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Multi-Asset-Characteristics" transform="translate(-36.000000, -318.000000)">
            <g id="Badge-/-Benchmark" transform="translate(36.000000, 318.000000)">
                <rect id="Rectangle" stroke="#FFCE00" fill="#FFFFFF" x="0.5" y="0.5" width="95" height="12" rx="6"></rect>
                <text id="Relative-to-Benchmar" font-family="FortBook" font-size="8" font-weight="300" line-spacing="11" fill="#000000">
                    <tspan x="5" y="9">Relative to Benchmark</tspan>
                </text>
            </g>
        </g>
    </g>
</svg>`;
